import React from 'react'

function EnrollmentProgress() {
  return (
    <div>EnrollmentProgress</div>
  )
}

export default EnrollmentProgress